const nimbleai = {
    model: {
        clientOnly: false,
        auth_token: null,
        user_id: null,
        loading: false,
        user: {
            id: null,
            name: '',
            email: '',
            image: '',
            slug: '',
            isCustomer: false,
            init: true,
            currentUsage: 0,
            company_id: null,
            whitelabel_id: null,
        },
        isNewChat: false,
        newMessageAdded: false,
        isNewChatGroup: false,
        foundationModels: [],
        apiKeys: [],
        whitelabelConfig: null,
        isWhitelabel: false,
        intendedRoute: null
    },
    utils: {},
    services: {
        userService: null,
        llmService: null,
        chatService: null,
        chatGroupService: null,
        messageService: null,
        folderService: null,
        promptService: null,
        apiKeyService: null
    }
}

export default nimbleai